<template>	
  <div class="row">
    <div class="col titre">
      <h2>Partage</h2>
    </div>
  </div>
  <div class="row">
              <DataTable
          class="p-datatable-sm"
          :value="dossiers"
          :resizableColumns="true"
          columnResizeMode="fit"
          :reorderableColumns="true"
          selectionMode="single"
          dataKey="cle"
          @row-select="onRowSelect"
          :paginator="true"
          :rows="10"
          paginatorPosition="both"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :rowsPerPageOptions="[10, 30, 100]"
          currentPageReportTemplate="Afficher {first} à {last} sur {totalRecords} dossiers"
        >
          <template #empty>
            <div v-if="isRechercheDataLoading == true" class="row">
              <div class="col">
                <vue-loaders  name="ball-beat" class = "justify-center"></vue-loaders>
              </div>
            </div>
            <div v-else class="row">
              &nbsp;&nbsp;&nbsp;Aucun enregistrement retourné
            </div>
          </template>
          <Column
            field="numeroCardex"
            header="Numéro Cardex"
            :sortable="true"
          ></Column>
          <Column
            field="numeroDossier"
            header="No Dossier"
            :sortable="true"
          ></Column>
          <Column
            field="reference1"
            header="Réf. 1"
            :sortable="true"
          ></Column>
          <Column
            field="reference2"
            header="Réf. 2"
            :sortable="true"
          ></Column>
          <Column
            field="reference3"
            header="Réf. 3"
            :sortable="true"
          ></Column>
          <Column
            field="severiteAfficher"
            header="Sév."
            :sortable="true"
          ></Column>
          <Column
            field="confidentialiteAfficher"
            header="Conf."
            :sortable="true"
          ></Column>
          <Column
            field="typeAfficher"
            header="Type"
            :sortable="true"
          ></Column>
          <Column
            field="categorieAfficher"
            header="Catégorie"
            :sortable="true"
          ></Column>
          <Column
            field="periode"
            header="Période"
            :sortable="true"
          ></Column>
          <Column
            field="statutAfficher"
            header="Statut"
            :sortable="true"
          ></Column>
          <Column
            field="debutDate"
            header="Date de début"
            :sortable="true"
          ></Column>
          <Column
            field="finDate"
            header="Date de fin"
            :sortable="true"
          ></Column>
          <Column
            field="creerPar"
            header="Intervenant"
            :sortable="true"
          ></Column>
        </DataTable>
    </div>
    <div class="row pt-2">
        <div class="col">
        <Button type="button" label="Fermer" @click="fermer"/>
        </div>  
    </div>  
</template>

<script>
import axios from "axios"
import { mapGetters } from 'vuex'

export default {
    name: "dossierPartage",
    mounted() {
      axios.defaults.headers.common["cleProfil"] = this.profil.cle;
      this.$root.$refs.breadcrumbComp.ajout("Partage Dossier");
      this.isRechercheDataLoading = true;
      this.$store
        .dispatch("dossier/obtenirDossiersPartagesAction")
        .then((res) => {
          this.dossiers = res.data;
          this.isRechercheDataLoading = false;
        });
    },
    data() {
      return {
        dossiers: [],
        isRechercheDataLoading: false
      };
    },
    computed: {
      ...mapGetters({
        jeton: 'cardex/jeton',
      profil: 'cardex/profil',
      })
    },
    methods: {    
        fermer() {
            this.$root.$refs.breadcrumbComp.rediriger();
        }, 
        onRowSelect(event) {
          this.$router.push({
            name: "dossierConsulter",
            params: {
              cle: event.data.cle,
              site: event.data.site,
            },
          });
        },
    }
}
</script>
